export enum LandingActionTypes {
    LANDING_REQUEST_SEND = 'landing_request_send',
    LANDING_ERROR = 'landing_error',
    LANDING_SUCCESS = 'landing_success',
    
    LANDING_CREATE_REQUEST = 'landing_create_request',
    LANDING_CREATE_SUCCESS = 'landing_create_success',
    LANDING_CREATE_ERROR = 'landing_create_error',

    LANDING_DELETE_REQUEST = 'landing_delete_request',
    LANDING_DELETE_SUCCESS = 'landing_delete_success',
    LANDING_DELETE_ERROR = 'landing_delete_error',

    LANDING_UPDATE_REQUEST = 'landing_update_request',
    LANDING_UPDATE_SUCCESS = 'landing_update_success',
    LANDING_UPDATE_ERROR = 'landing_update_error',
}